import * as yup from 'yup';
import { integerIn, requiredText, ROOM_CAPACITY_BOUNDS, TranslateFn } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/** The API's width for `rooms.name`, changelog 047. */
export const ROOM_NAME_MAX = 120;

/**
 * A room with no services is allowed: it limits nothing yet, which is a real state while an
 * administrator is still setting the clinic up. Which services are free to tick is the
 * dialog's business, since it depends on the other rooms rather than on this form.
 */
export const createRoomSchema = (translate: TranslateFn) => yup.object({
    name: requiredText(translate, ResourcesIds.ROOMS_NAME_REQUIRED, ROOM_NAME_MAX),
    capacity: integerIn(ROOM_CAPACITY_BOUNDS, translate, ResourcesIds.ROOMS_CAPACITY_INVALID,
        { required: true }),
    catalogTypeIds: yup.array().of(yup.number().defined()).defined(),
});
